import defaultLocale from '@niaratech/niara-react-components/lib/util/defaultLocale'
import queryString from 'query-string'
import callApi from '../util/callApi'
import type { HotelDetails } from '../types/hotels'

export default async function fetchHotelDetails(
  hotelId: string,
  locale = defaultLocale(),
  tenantId: string,
  clientId: string,
  detailsUrl: string
): Promise<HotelDetails> {
  if (locale == 'xh' || locale == 'xx') {
    locale = 'en'
  }
  if (detailsUrl) {
    return fetch(detailsUrl, {
      headers: {
        ['Accept-Language']: locale,
      },
    })
      .then((response) => response.json())
      .catch(() => null)
  }

  const _hotelId = hotelId?.match(/^([a-zA-Z0-9]+)_([a-zA-Z0-9]+)_([a-zA-Z0-9]+)/)?.[0] ?? undefined
  if (!_hotelId) return null
  return await callApi(
    'niara-spear-resource',
    `/hotels/${encodeURIComponent(_hotelId)}?${queryString.stringify({ locale, tenantId, clientId })}`,
    'get'
  )
    .then((r): HotelDetails => {
      if (r && !r?.hotelId) {
        r.hotelId = hotelId
      }
      return r as HotelDetails
    })
    .catch(() => null)
}
